import * as normalizr from 'normalizr'
import * as R from 'ramda'
import { records } from '@ims/1edtech-frontend-common'

import { getCCLomAndDisclosures } from 'lib/records/modules/commonCartridgeCharacterizationReports'

export const COMMON_CARTRIDGE_CHARACTERIZATION_REPORT_RESOURCES_RECORD =
  'commonCartridgeCharacterizationReportResources'

const commonCartridgeCharacterizationReportResources: records.modules.IModule = {
  record: COMMON_CARTRIDGE_CHARACTERIZATION_REPORT_RESOURCES_RECORD,
  schema: new normalizr.schema.Entity(
    COMMON_CARTRIDGE_CHARACTERIZATION_REPORT_RESOURCES_RECORD,
    {},
    {
      processStrategy: R.compose((resource) => {
        const [lom, disclosures] = getCCLomAndDisclosures(resource)
        return {
          ...resource,
          lom,
          disclosures,
        }
      }, records.modules.utils.fixIdAttribute),
      idAttribute: 'id',
    },
  ),
  api: {
    create: () => '',
    get: (id) => `ccsys/resources/${id}`,
    getList: (params, parentId) => {
      const isCartridge = R.propOr(false, 'isCartridge', params)
      if (isCartridge) {
        return `ccsys/cartridges/${parentId}/resources`
      }
      return `ccsys/standards/${parentId}/resources`
    },
    update: () => '',
    delete: () => '',
  },
}

export default commonCartridgeCharacterizationReportResources
